import { render, staticRenderFns } from "./BowVideo.vue?vue&type=template&id=256cefc3&"
import script from "./BowVideo.vue?vue&type=script&lang=js&"
export * from "./BowVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports